module.exports = __webpack_public_path__ + "static/media/crane-2.128e340e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/SwiftBankingResources/crane-2.svg
// module id = 26
// module chunks = 0